<template>
  <div :class="disable ? 'tw-text-gray-300 block-header':'block-header'">
    <span class="small-span">{{ title }}</span>
    <span class="q-table__title">{{ content }}</span>

  </div>
</template>

<script>
export default {
  name: 'BlockHeader',
  props: {
    title: String,
    content: String,
    disable: Boolean
  }
}
</script>
<style scoped>
@import "tailwindcss/utilities";
</style>
